









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloPartenaire, getDefaultAloPartenaire } from '@/models/alo/AloPartenaire';

@Component({
  name: 'EditBasePartenaire',    
  components:{EditDrawer},
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBasePartenaire extends Vue {
  
  private original = getDefaultAloPartenaire()
  private modified = getDefaultAloPartenaire()
  private showDrawer = false
  private saving = false 

  edit(item:AloPartenaire) {        
    this.$store.myActions.ADM_PARTENAIRE_RESET_STATUS()
    this.showDrawer = true
    this.original = item
    this.modified = cloneDeep(item) 

    return this.modified   
  }  

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get partenaireStatus() {
    return this.$store.myGetters.partenaireStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_PARTENAIRE_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.partenaireStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

  
}
